import React from "react";
import { LegalHero, LegalBody, H2, LastUpdated } from "./legalHelpers";
import ObfuscatedEmail from "../components/ObfuscatedEmail";
import { usePageMeta } from "../components/Layout";

export default function CookiesPage() {
    usePageMeta({
        title: "Cookie Notice | London Renovation Specialists",
        description: "How this website uses cookies.",
    });
    return (
        <div data-testid="cookies-page">
            <LegalHero
                eyebrow="Cookies"
                title="Cookie Notice"
                intro="How this website uses cookies."
            />
            <LegalBody>
                <LastUpdated />

                <H2>Essential cookies only</H2>
                <p>
                    This website uses only essential cookies required for the site to function correctly, remain
                    secure, and be administered.
                </p>

                <H2>What we do not use</H2>
                <p>
                    We do not use advertising cookies. We do not use behavioural tracking. We do not use
                    third-party analytics cookies at this time. There is no Meta Pixel or equivalent tracking
                    technology on this site.
                </p>

                <H2>Your choice</H2>
                <p>
                    Because we only use essential cookies required for basic site functionality, we do not require
                    a detailed cookie-consent management interface. The small notice at the bottom of the site
                    confirms that essential cookies are in use; clicking "OK" simply dismisses the notice.
                </p>

                <H2>If this changes</H2>
                <p>
                    If we ever introduce non-essential cookies, we will update this page and provide an
                    appropriate consent mechanism at that time.
                </p>

                <H2>Questions</H2>
                <p>
                    Any questions about how this site uses cookies can be sent to{" "}
                    <ObfuscatedEmail user="hello" domain="londonrenovationspecialists.com" className="underline hover:text-terracotta" />.
                </p>
            </LegalBody>
        </div>
    );
}
